<div class="row">
  <div class="lqd-column col-md-12">
    <h2 appTranslate="congratulations.title1"></h2>
    <p appTranslate="congratulations.text1"></p>
    <p appTranslate="congratulations.title2" class="font-weight-bold"></p>
    <p appTranslate="congratulations.text2"></p>

    <app-login hidden></app-login>
  </div>

  <!-- <div class="lqd-column col-md-5 col-md-offset-2">
    <h2 appTranslate="repatriate.title"></h2>
    <p appTranslate="repatriate.text"></p>

    <a (click)="next()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2">
      <span class="btn-txt" appTranslate="congratulations.repatriate"></span>
    </a>
  </div> -->
</div>

